export const navAccent = "#0a104d";
export const navIconBg = "#eceaf3";
export const desktopNavWidth = "260px";
export const desktopNavPadding = "20px";
export const desktopNavScrollCss = {
  display: "flex",
  flexDirection: "column" as const,
  flex: 1,
  minHeight: 0,
  overflowY: "auto" as const,
  overflowX: "hidden" as const,
  marginRight: `calc(-1 * ${desktopNavPadding})`,
};

export const desktopNavScrollContentCss = {
  display: "flex",
  flexDirection: "column" as const,
  gap: "1.5rem",
  paddingRight: desktopNavPadding,
  minHeight: "100%",
};

export const desktopNavScrollFooterCss = {
  display: "flex",
  flexDirection: "column" as const,
  gap: "1.5rem",
  marginTop: "auto",
  flexShrink: 0,
};
export const mobileNavBarHeight = "62px";
export const mobileNavCollapsedBarHeightPx = Number.parseInt(mobileNavBarHeight, 10);
